import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';
import { colors } from '../../theme/modules/colors';
import { SuccessIcon } from '../../tempIcons/SuccessIcon';
import { sizes } from '../../theme/modules/sizes';
import { Button } from '../Button';
import { ClipboardIcon } from '../../tempIcons/ClipboardIcon';
const iconSizes = { width: sizes.base, height: sizes.base };
/**
 * Created in here to fix orders table sizes. Bad pattern to use in main button component, as
 * touch target is below A11y guidelines.
 */
const XSButton = styled(Button).withConfig({ displayName: "vui--XSButton", componentId: "vui--e6p1xr" }) `padding:1px;height:unset;span{height:${sizes.base};width:${sizes.base};top:unset;}`;
/**
 * A dynamic button to facilitate copying text to a users' keyboard when clicked.
 */
export const CopyToClipboard = ({ className, text, onCopy }) => {
    const [copied, setCopied] = React.useState(false);
    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(text);
        if (onCopy)
            onCopy();
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
    }, [onCopy, text]);
    return (React.createElement(Tooltip, { text: copied ? 'Copied!' : 'Copy to clipboard' },
        React.createElement(XSButton, { variant: "flat", size: "sm", className: className, "aria-label": `${copied ? 'Copied' : 'Copy'} "${text}" to clipboard`, icon: copied ? (React.createElement(SuccessIcon, Object.assign({ color: colors.secondary.green.base }, iconSizes))) : (React.createElement(ClipboardIcon, Object.assign({ color: colors.secondary.blue.base }, iconSizes))), onClick: handleCopy })));
};
//# sourceMappingURL=CopyToClipboard.js.map